export class ClientInteractionDeletedEvent {
  get type() {
    return ClientInteractionDeletedEvent.type;
  }
  constructor(readonly payload: number) {}
  static type = 'ClientInteractionDeleted';
}
